'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _schema = require('./schema');

var _schema2 = _interopRequireDefault(_schema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Soompi = function () {
  function Soompi(options) {
    _classCallCheck(this, Soompi);

    var defaultOpt = {
      timeout: 20000,
      headers: { 'Content-Type': 'multipart/form-data' },
      params: {}
    };

    this.opt = Object.assign({}, defaultOpt, options);
    _api2.default.insert(_schema2.default, this, this.opt);
  }

  /*
    A generic method that allows us to call any API endpoint without the
    need of generating a function through schema.js. This will make it easier for APIs to
    be called directly without the need of editing schema.js
     @return Promise
  */


  _createClass(Soompi, [{
    key: 'request',
    value: function request(url, params, opt) {
      return _api2.default.request(url, params, Object.assign({}, this.opt, opt));
    }

    /*
      A specific API that returns posts API function based on the type requested
       @return Object
    */

  }, {
    key: 'getTopic',
    value: function getTopic(type) {
      var mapper = {
        category: this.getCategoryPosts,
        tag: this.getTagPosts,
        fanClub: this.getFanClubPosts
      };

      return mapper[type];
    }

    /*
      A specific API that returns an a generated API function based on the type requested
       @return Object
    */

  }, {
    key: 'getPostsBy',
    value: function getPostsBy(type) {
      var mapper = {
        trending: this.getTrending,
        popular: this.getPopular
      };

      var api = mapper[type] ? mapper[type] : this.getLatest;
      return api;
    }
  }]);

  return Soompi;
}();

exports.default = Soompi;


if (typeof window !== 'undefined') {
  window.Soompi = Soompi;
}


// WEBPACK FOOTER //
// ./submodules/soompi-js/dist/node/soompi.js